/**
 * Host and co-host invitation for web streaming.
 */
export const INVITATION_URL_QUERY_KEY = 'fwinvite'
export const INVITATION_TOKEN_KEY = 'invitation_token'
export const INVITATION_TYPE_KEY = 'invitation_type'
export const INVITATION_LIVE_STREAM_ID_KEY = 'live_stream_id'
